import React, { Fragment } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet-async'
import './MdxContent.scss'

function MdxContent({ children, slug, pageContext }) {
  const { title, image } = pageContext.frontmatter

  return (
    <StaticQuery
      query={graphql`
        query blogIndex {
          allMdx {
            edges {
              node {
                excerpt
                fields {
                  slug
                }
              }
            }
          }
        }
      `}
      render={({ allMdx }) => {
        const post = allMdx.edges.find(({ node }) => node.fields.slug === slug)
        let excerpt
        if (post) excerpt = post.node.excerpt

        // For Open Graph Social Media Meta Tags:
        // Always customize the meta title and description. If frontmatter meta
        // info isn't defined, use the other frontmatter by default
        const meta = pageContext.frontmatter.meta || {}
        meta.title = meta.title || title
        meta.description = meta.description || excerpt
        meta.image = meta.image || image
        if (meta.image && !meta.image.startsWith('http')) {
          meta.image =
            process.env.GATSBY_ACTIVE_ENV === 'production'
              ? `https://reacttraining.com${meta.image}`
              : `https://reactjs-training-staging.firebaseapp.com${meta.image}`
        }

        return (
          <Fragment>
            <Helmet>
              {meta.title && <title>React Training: {meta.title}</title>}
              {meta &&
                Object.keys(meta).map(metaProp => {
                  if (!meta[metaProp]) return null
                  return (
                    <meta
                      key={metaProp}
                      property={`og:${metaProp}`}
                      content={meta[metaProp]}
                    />
                  )
                })}
            </Helmet>
            <div className="mdx-content">{children}</div>
          </Fragment>
        )
      }}
    />
  )
}

export default MdxContent
